var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MyPage',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSearchState === 'view'),expression:"currentSearchState === 'view'"}],attrs:{"current":"MyPage"}}),_vm._v(" "),(_vm.currentSearchState === 'result')?_c('RouteResult',{attrs:{"current":"MyPage"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8b1c96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPageRoot.vue
// module id = null
// module chunks = 